const DefaultConfig = {
  backendURL: "https://www.alemoil.com/api", // 'http://localhost:3001'
};

export default DefaultConfig;
